import { Component, Inject } from '@angular/core';

import { EntityCheckboxListComponent } from '../../shared/checkbox-list/components/entity-checkbox-list.component';

import { StaticTypeService } from '../services/static-types.service';
import { TypeAcces } from '../entities/type-acces.entity';

@Component({
	selector: 'type-acces-checkbox-list',
	templateUrl: '../../shared/checkbox-list/components/entity-checkbox-list.html',
	styleUrls: ['../../shared/checkbox-list/components/entity-checkbox-list.css']
})
export class TypeAccesCheckboxListComponent extends EntityCheckboxListComponent<TypeAcces> {
	// Label du champ
	override label = "Type Accès";
	
	// Label de l'option neutre
	override wildcardOptionLabel = "Toutes";

	// Fonction determinant le label d'un parc
	override getEntityLabel = (typeAcces: TypeAcces) => typeAcces.label;

	constructor( //
		@Inject(StaticTypeService) private staticTypesService: StaticTypeService //
	) {
		super();
		this.staticTypesService.getTypeAccesList().subscribe(
			(list: TypeAcces[]) => this.entities = list
		);
	}
}